import $ from 'jquery';

$(function() {
    let map;
    /**
     * initMap
     *
     * Renders a Google Map onto the selected jQuery element
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   jQuery $el The jQuery element.
     * @return  object The map instance.
     */
    function initMap( $el ) {

        // Find marker elements within map.
        var $markers = $el.find('.marker');

        // Create gerenic map.
        var mapArgs = {
            zoom        : $el.data('zoom') || 16,
            mapTypeId   : google.maps.MapTypeId.ROADMAP,
            mapId       : 'alpine-park-313414',
        };
        let map = new google.maps.Map( $el[0], mapArgs );

        // add overlay
        const bounds = new google.maps.LatLngBounds(
            new google.maps.LatLng(50.90599913967988, -114.15290137815834),
            new google.maps.LatLng(50.92269351171021, -114.13225950498939)
        );

        /**
         * The custom USGSOverlay object contains the USGS image,
         * the bounds of the image, and a reference to the map.
         */
        class USGSOverlay extends google.maps.OverlayView {
                bounds;
                image;
                div;
                constructor(bounds, image) {
                super();
                this.bounds = bounds;
                this.image = image;
            }
            /**
             * onAdd is called when the map's panes are ready and the overlay has been
             * added to the map.
             */
            onAdd() {
                this.div = document.createElement("div");
                this.div.style.borderStyle = "none";
                this.div.style.borderWidth = "0px";
                this.div.style.position = "absolute";
                // Create the img element and attach it to the div.
                const img = document.createElement("img");
                img.src = this.image;
                img.style.width = "100%";
                img.style.height = "100%";
                img.style.position = "absolute";
                this.div.appendChild(img);
                // Add the element to the "overlayLayer" pane.
                const panes = this.getPanes();
                panes.overlayLayer.appendChild(this.div);
            }
            draw() {
                // We use the south-west and north-east
                // coordinates of the overlay to peg it to the correct position and size.
                // To do this, we need to retrieve the projection from the overlay.
                const overlayProjection = this.getProjection();
                // Retrieve the south-west and north-east coordinates of this overlay
                // in LatLngs and convert them to pixel coordinates.
                // We'll use these coordinates to resize the div.
                const sw = overlayProjection.fromLatLngToDivPixel(
                    this.bounds.getSouthWest()
                );
                const ne = overlayProjection.fromLatLngToDivPixel(
                    this.bounds.getNorthEast()
                );

                // Resize the image's div to fit the indicated dimensions.
                if (this.div) {
                    this.div.style.left = sw.x + "px";
                    this.div.style.top = ne.y + "px";
                    this.div.style.width = ne.x - sw.x + "px";
                    this.div.style.height = sw.y - ne.y + "px";
                }
            }
        }
        let image = "/app/themes/sage/images/AP_Brand_Alpine_Park_Phase_Map_v22.1_LotFX_V2.png";

        const overlay = new USGSOverlay(bounds, image);
        overlay.setMap(map);

        // I create an OverlayView, and set it to add the "markerLayer" class to the markerLayer DIV
        var myoverlay = new google.maps.OverlayView();
        myoverlay.draw = function () {
            this.getPanes().markerLayer.id='markerLayer';
        };
        myoverlay.setMap(map);

        // Add markers.
        map.markers = [];
        $markers.each(function(){
            initMarker( $(this), map );
        });

        // Center map based on markers.
        centerMap( map );

        // Return map instance.
        return map;
    }

    /**
     * initMarker
     *
     * Creates a marker for the given jQuery element and map.
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   jQuery $el The jQuery element.
     * @param   object The map instance.
     * @return  object The marker instance.
     */
    function initMarker( $marker, map ) {
        // Get position from marker.
        var lat = $marker.data('lat');
        var lng = $marker.data('lng');
        var id  = $marker.data('id');
        var color = $marker.data('color');
        var latLng = {
            lat: parseFloat( lat ),
            lng: parseFloat( lng )
        };

        let icon;

        if($marker.data('icon')) {
            icon = $marker.data('icon');
        } else {
            icon = $(`.js-ammenity-type[data-id=${$marker.data('term_id')}]`).data('icon');
        }

        // if(!icon) return false;

        // const image = {
        //     url: icon,
        //     // This marker is 20 pixels wide by 32 pixels high.
        //     //size: new google.maps.Size(20, 20),
        //     // The origin for this image is (0, 0).
        //     //origin: new google.maps.Point(0, 0),
        //     // The anchor for this image is the base of the flagpole at (0, 32).
        //     //anchor: new google.maps.Point(0, 32),
        //     scaledSize: new google.maps.Size(20, 20),
        //     shape:{coords:[10,10,11],type:'circle'},
        // };

        const pinSvgString = color
      ? `<svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g><rect width="100" height="100" rx="50" fill="${color}" /></g></svg>`
      : `<img src="${icon}" style="width: 20px; height: 20px; border-radius: 50%;">`;

        const parser = new DOMParser();
        const pinSvg = color
            ? parser.parseFromString(pinSvgString, "image/svg+xml").documentElement
            : parser.parseFromString(pinSvgString, "text/html").body.firstElementChild;

        // Create marker instance.
        var marker = new google.maps.marker.AdvancedMarkerElement({
            position : new google.maps.LatLng(latLng),
            map: map,
            content: pinSvg,
        });
        marker.id = id;
        marker.term_id = $marker.data('term_id');
        marker.parent_id = $marker.data('parent_id');
        // marker.icon = image;

        // Append to reference for later use.
        map.markers.push( marker );

        // If marker contains HTML, add it to an infoWindow.
        if (color) {
            if( $marker.html() ){

            // Create info window.
            var infowindow = new google.maps.InfoWindow({
                content: $marker.html()
            });

            // Show info window when marker is clicked.
            google.maps.event.addListener(marker, 'click', function() {
                infowindow.open( map, marker );
            });
        }
    }
  }
    /**
     * centerMap
     *
     * Centers the map showing all markers in view.
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   object The map instance.
     * @return  void
     */
    function centerMap( map ) {

        // Create map boundaries from all map markers.
        var bounds = new google.maps.LatLngBounds();
        map.markers.forEach(function( marker ){
            bounds.extend({
                lat: marker.position.lat,
                lng: marker.position.lng
            });
        });

        // Case: Single marker.
        if( map.markers.length == 1 ){
            map.setCenter( bounds.getCenter() );

        // Case: Multiple markers.
        } else{
            map.fitBounds( bounds );
        }
    }

    function showOnlyRootAmenities() {
        let bounds = new google.maps.LatLngBounds();
        let found = 0;
        map.markers.forEach(function( marker ){
            if( typeof marker.parent_id == 'undefined') {
                bounds.extend({
                    lat: marker.position.lat,
                    lng: marker.position.lng
                });
                marker.map = map;
                found++;
            } else {
                marker.map = null;
            }
        });
        centerOrBound( found, bounds);
    }

    // Show amenities feature
    function showAmenitiesFor( id ) {
        let bounds = new google.maps.LatLngBounds();

        let found = 0;
        let amenityMarker;

        map.markers.forEach(function( marker ){
            if( marker.id == id ) amenityMarker = marker;
            if( marker.parent_id == id || marker.id == id) {
                bounds.extend({
                    lat: marker.position.lat,
                    lng: marker.position.lng
                });
                marker.map = map;
                found++;
            } else if(typeof marker.parent_id != 'undefined') {
                marker.map = null;
            }
        });
        centerOrBound( found, bounds);
    }

    // Show specific feature
    function showFeaturesFor( term_id, parent_id ) {
        let bounds = new google.maps.LatLngBounds();
        let found = 0;
        map.markers.forEach(function( marker ){
            if( (marker.term_id == term_id && marker.parent_id == parent_id) || marker.id == parent_id) {
                bounds.extend({
                    lat: marker.position.lat,
                    lng: marker.position.lng
                });
                marker.map = map;
                found++;
            } else if(typeof marker.parent_id != 'undefined') {
                marker.map = null;
            }
        });

        centerOrBound( found, bounds);
    }

    function centerOrBound( found, bounds) {
        if(found <= 2) {
            map.setCenter( bounds.getCenter() );
            map.setZoom(18);
        } else {
            map.fitBounds( bounds );
        }
    }

    // Render maps on page load.
    $(function(){
        $('.acf-map').each(function(){
            map = initMap( $(this) );
            showOnlyRootAmenities();
        });

        $(document).on('click', '.js-mobile-categories', function(e) {
            e.preventDefault();
            $('.js-amenity-list').toggleClass('hidden');
        });

        $(document).on('click', '.js-ammenity-location', function(e) {
            e.preventDefault();
            e.stopPropagation();
            $('.js-amenity-list').addClass('hidden');
            showAmenitiesFor($(this).data('id'));
        });

        $(document).on('click', '.js-feature', function(e) {
            e.preventDefault();
            e.stopPropagation();
            $('.js-amenity-list').addClass('hidden');
            showFeaturesFor( $(this).data('term_id'), $(this).data('parent_id') );
        });

        $(document).on('click', '.js-ammenity-type', function(e) {
            e.preventDefault();
            // go through and hide / unhide the matches
            const $childList = $(this).find('.amenity-list__child');
            const $childTitleList = $(this).find('.amenity-title-container');
            // $('.js-amenity-list').removeClass('hidden');
            if($childList.hasClass('open')) {
                // show all roots
                showOnlyRootAmenities();
                $childList.removeClass('open');
                $childTitleList.removeClass('open');
            } else {
                $('.amenity-list__child').removeClass('open');
                $('.amenity-title-container').removeClass('open');

                $childList.addClass('open');
                $childTitleList.addClass('open');
            }

        });
    });

});
